import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExportFilenameService {

  static generate(
    page: string,
    statisticName?: string,
    projectName?: string, 
    trainName? : string, 
    startPeriod? : Date, 
    endPeriod?: Date
    ) {

    const datePipe = new DatePipe('en');
    const now = datePipe.transform(new Date(), 'dd-MM-yyyy');
    let fileName = `${page}` ;
    fileName += projectName ? `_${projectName}`: ''; 
    fileName += statisticName ? `_${statisticName}`: ''; 
    fileName += trainName ? `_${trainName}`: ''; 
    fileName += startPeriod ? `_${endPeriod ? 'From_': 'On_'}${datePipe.transform(new Date(startPeriod), 'dd-MM-yyyy')}`: ''; 
    fileName += endPeriod ? `_To_${datePipe.transform(new Date(endPeriod), 'dd-MM-yyyy')}`: ''; 
    fileName += `_ExportedOn_${now}`;

    return fileName;
  }
}
